import icons from "../../../../../Data/icons";
import classes from "./addCompanyFields.module.css";

const AddCompanyFields = ({
  setCompanyFieldName,
  companyFiledName

  
}) => {
  const CompanyFiled = icons.company;

  const handleNameChange = (e) => {
    setCompanyFieldName(e.target.value);
  };


  return (
    <div className={classes.formCard}>
   

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">مجال الشركة </label>
          <div className={classes.iconInput}>
            <CompanyFiled />
          </div>
          <input
            type="text"
            placeholder="ادخل  مجال الشركة"
            value={companyFiledName}
            onChange={handleNameChange}
            className={classes.inputCustom}
          />
        </div>
     
     
      </div>
    </div>
  );
};

export default AddCompanyFields;
